import React from 'react';
import Moment from 'moment';
import Track from '../../../../Common/fTrack';
import { timelineLogStatus } from '../../fProcurement/fPoAmend/GRN/GrnView/Timeline';



const Index = ({timelines}) => {

    return(
        <div id="Invoice_Timeline" className='FadeRight-Effect'>
			<div style={{fontSize: '14px', fontWeight: 'bold', margin: '30px 0px 10px 0px'}}>Timeline</div>
			<Track stages={
				[...timelines.map((log,index) => {

                    let DESC = <div><b>{log.name}</b><br/>
                        <div style={{marginTop: '5px'}}>Type: {log.type}</div>
                        <div style={{marginTop: '5px'}}>Status: {log.status}</div>

                        {
                            (log.emulatedByName && log.emulatedByCode) &&
                            <div style={{margin:'2px 0'}} >
                                <p>EA Access Name: {log.emulatedByName}</p>
                                <p>EA Access Code: {log.emulatedByCode}</p>
                            </div>
                        }
                        <div style={{marginTop: '5px'}}>Sent
                            on: {Moment(log.time).format("hh:mm a DD MMM YY")}
                            <br/>{log.actionTime && log.status !== 'PENDING' ? `Approved on: ${Moment(log.actionTime).format(" hh:mm a DD MMM YY")}` : ''}
                        </div>
                        {(log.status==="REVERTED" && log.revertedRemarks)? <div style={{marginTop: '5px'}}>Revert remarks: {log.revertedRemarks}</div> : null}
                    </div>

                    return (
                        {
                            title: log.email,
                            desc: DESC,
                            skipped: log.status === 'SKIPPED' ? true : false,
                            status: log.type === 'start' || log.type === 'scanner-end' || log.status === 'APPROVED' || (log.type === 'scanner-start' && timelines.length>(index+1))? true : log.status ? timelineLogStatus.includes(log.status) : log.name === 'Finance Action' || log.type === 'Completed' || log.email === 'Action completed by Admin' || log.type === 'Taxation Approval' ?  true : false
                        })
                })]
            }/>									
		</div>
    )
}

Index.defaultProps = {
    timelines:[]
}

export default Index;